import React from 'react';
import { Text, VStack } from '@chakra-ui/react';
import ModalShell from '../../../components/ui/ModalShell';
import { ff } from '../../../theme';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  isLoading?: boolean;
  footerWarning?: {
    text: string;
    subtext?: string;
  };
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  isLoading = false,
  footerWarning
}) => {
  return (
    <ModalShell
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      cancelLabel="Cancel"
      primary={{ label: confirmText, onClick: onConfirm, isLoading }}
    >
      <VStack spacing={4} align="stretch">
        <Text fontSize="16px" lineHeight="1.45" color={ff.text2}>{message}</Text>
        {footerWarning && (
          <VStack spacing="4px" align="stretch" bg="#FBE1DC" borderRadius="16px" p="14px">
            <Text fontSize="14px" lineHeight="1.4" fontWeight="600" color="#A1260F">
              {footerWarning.text}
            </Text>
            {footerWarning.subtext && (
              <Text fontSize="14px" lineHeight="1.4" color="#3E3E42">
                {footerWarning.subtext}
              </Text>
            )}
          </VStack>
        )}
      </VStack>
    </ModalShell>
  );
};

export default ConfirmationModal;
